import React from 'react';
import { Navigate } from 'react-router';
import { isAppAdmin } from './_redux';
import { useAppSelector } from './_redux/hooks';

/** Renders /admin only for app_admins (the API's admin role); anyone else lands on / with the URL out of history. */
const RequireAppAdmin = ({ children }: { children: React.ReactNode }) => {
  const allowed = useAppSelector(isAppAdmin);
  return allowed ? <>{children}</> : <Navigate replace to="/" />;
};

export default RequireAppAdmin;
